'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _MixerDownloadPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/MixerDownloadPopup');

var _MixerDownloadPopup2 = _interopRequireDefault(_MixerDownloadPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MixerDownloadPopupContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(MixerDownloadPopupContainer, _React$Component);

  function MixerDownloadPopupContainer(props) {
    (0, _classCallCheck3.default)(this, MixerDownloadPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MixerDownloadPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(MixerDownloadPopupContainer)).call(this, props));

    _this.state = {
      type: '',
      downloadableLink: ' '
    };
    _this.onChangeHandler = _this.onChangeHandler.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(MixerDownloadPopupContainer, [{
    key: 'onChangeHandler',
    value: function onChangeHandler(e) {
      var value = e.target.value;
      var _props = this.props,
          platform = _props.platform,
          latestStudio = _props.latestStudio;

      var downloadLink = "";
      if (value == 'ms') {
        downloadLink = platform === 'linux' ? '' : platform === 'windows' ? latestStudio.Url : latestStudio.UrlMac;
      } else if (value == 'mb') {
        downloadLink = platform === 'linux' ? '' : platform === 'windows' ? latestStudio.expUrl : latestStudio.expUrlMac;
      }
      downloadLink = downloadLink || ' ';
      this.setState({
        type: value,
        downloadableLink: downloadLink
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_MixerDownloadPopup2.default, {
        icon: 'https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/mixer_icon_2048_preview.png',
        title: 'Download Mixer',
        type: this.state.type,
        downloadableLink: this.state.downloadableLink
        // onDownloadClick={this.onDownloadClick.bind(this)}
        , onChangeHandler: this.onChangeHandler
      });
    }
  }]);
  return MixerDownloadPopupContainer;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = MixerDownloadPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MixerDownloadPopupContainer/MixerDownloadPopupContainer.jsx
// module id = 2640
// module chunks = 0